import React, { useState, useMemo, useRef } from "react";
import { AgGridReact } from "ag-grid-react";
import { AllCommunityModule, ModuleRegistry } from "ag-grid-community";
import CustomCheckboxFilter from "../../../utils/CustomCheckboxFilter";
// import StatusRender from "../../../utils/StatusRenderer";
import CustomButton from "../../../utils/CustomButtonOperator";
import SearchFilter from "../../../utils/SearchFilter";
import MarketToggleButton from "../../../utils/MarketToggleButton";

ModuleRegistry.registerModules([AllCommunityModule]);

const MarketTable = ({
  markets,
  onEdit,
  onDelete,
  getAdminDashboardMarkets,
}) => {
  // const [rowData, setRowData] = useState([]);
  const [quickFilterText, setQuickFilterText] = useState("");
  const gridRef = useRef(null);

  // useEffect(() => {
  //   setRowData(markets);
  // }, [markets]);
  const onGridReady = (params) => {
    gridRef.current = params.api;
  };

  const handleQuickFilterChange = (e) => {
    setQuickFilterText(e.target.value);
  };
  const columnDefs = useMemo(
    () => [
      {
        headerName: "Sl.No",
        valueGetter: (params) => {
          const currentPage = params.api.paginationGetCurrentPage();
          const pageSize = params.api.paginationGetPageSize();
          const rowIndex = params.node.rowIndex;
          return currentPage * pageSize + rowIndex + 1;
        },
        maxWidth: 100,
      },
      {
        field: "name",
        headerName: "Name",
        filter: CustomCheckboxFilter,
      },
      {
        headerName: "Status",
        field: "status",
        filter: CustomCheckboxFilter,
        cellRenderer: MarketToggleButton,
        flex: 1,
        cellRendererParams: {
          refreshList: getAdminDashboardMarkets,
        },
      },

      {
        headerName: "Actions",
        field: "actions",
        cellRenderer: CustomButton,
        suppressMenu: true,
        sortable: false,
        filter: false,
        cellClass: "flex justify-start mt-6",
      },
    ],
    [getAdminDashboardMarkets]
  );

  const defaultColDef = {
    flex: 1,
    sortable: true,
    resizable: true,
  };

  return (
    <>
      {/* Search Input */}
      <div className="mb-4">
        <SearchFilter
          value={quickFilterText}
          onChange={handleQuickFilterChange}
        />

        {/* <button
          onClick={handleExport}
          className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
        >
          Export CSV
        </button> */}
      </div>

      {/* AG Grid Table */}
      <div
        className="ag-theme-alpine"
        style={{ height: "750px", width: "100%" }}
      >
        <AgGridReact
          rowData={markets}
          quickFilterText={quickFilterText}
          columnDefs={columnDefs}
          defaultColDef={defaultColDef}
          pagination={true}
          paginationPageSize={20}
          onGridReady={onGridReady}
          context={{ onEdit, onDelete }}
          enableCellTextSelection={true}
          overlayNoRowsTemplate="<span style='padding: 10px; display: block;'>No data found</span>"
          onFilterChanged={(params) => {
            const rowCount = params.api.getDisplayedRowCount();
            if (rowCount === 0) {
              params.api.showNoRowsOverlay();
            } else {
              params.api.hideOverlay();
            }
          }}
        />
      </div>
    </>
  );
};

export default MarketTable;
